import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comparator',
  templateUrl: './comparator.component.html',
  styleUrls: ['./comparator.component.css']
})
export class ComparatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
